/**
 * OUTFIT SUGGERITI — JavaScript
 * Gestisce: carosello, aggiunta al carrello AJAX, toast, refresh drawer
 */

const OutfitSuggeriti = (() => {

  // ── Carosello ──────────────────────────────────────────────
  function scroll(direction) {
    const track = document.getElementById('outfit-track');
    if (!track) return;
    const cardWidth = track.querySelector('.outfit-card')?.offsetWidth || 196;
    track.scrollBy({ left: direction * (cardWidth + 16) * 2, behavior: 'smooth' });
  }

  // ── Aggiungi al carrello (AJAX) ────────────────────────────
  async function addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.classList.add('loading');
    btn.textContent = 'Aggiunta…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || 'Errore aggiunta');
      }

      btn.textContent = '✓ Aggiunto';
      showToast();
      refreshCart();

      setTimeout(() => {
        btn.classList.remove('loading');
        btn.textContent = originalText;
      }, 2200);

    } catch (err) {
      console.error('[OutfitSuggeriti]', err.message);
      btn.classList.remove('loading');
      btn.textContent = originalText;
      alert('Non è stato possibile aggiungere il prodotto. Riprova.');
    }
  }

  // ── Toast ──────────────────────────────────────────────────
  let toastTimer = null;
  function showToast() {
    const toast = document.getElementById('outfit-toast');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.removeAttribute('hidden');
    void toast.offsetWidth;
    toast.classList.add('visible');
    toastTimer = setTimeout(() => {
      toast.classList.remove('visible');
      setTimeout(() => toast.setAttribute('hidden', ''), 300);
    }, 2500);
  }

  // ── Refresh carrello / drawer ──────────────────────────────
  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // Aggiorna contatore nella navbar (selettori comuni a molti temi)
        document.querySelectorAll(
          '.cart-count, .cart-item-count, [data-cart-count], .cart__count, #cart-count, .header__cart-count'
        ).forEach(el => { el.textContent = cart.item_count; });

        // Evento generico per aprire/aggiornare il drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart-update', { detail: { cart } }));
      })
      .catch(() => {});
  }

  // ── Opacità frecce nav ─────────────────────────────────────
  function init() {
    const track = document.getElementById('outfit-track');
    const prev  = document.querySelector('.outfit-nav--prev');
    const next  = document.querySelector('.outfit-nav--next');
    if (!track || !prev || !next) return;

    function updateNav() {
      prev.style.opacity = track.scrollLeft > 8 ? '1' : '0.3';
      next.style.opacity = (track.scrollLeft + track.clientWidth < track.scrollWidth - 8) ? '1' : '0.3';
    }
    track.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }

  document.addEventListener('DOMContentLoaded', init);

  return { scroll, addToCart };
})();
